export default function Instagram({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        fill="currentColor"
        d="M12.5,8.8c-0.2,0-0.3,0-0.5,0s-0.3,0-0.5,0c-1.7,0.3-2.9,1.9-2.7,3.6c0.3,1.7,1.9,2.9,3.6,2.7
        c0.8-0.1,1.6-0.6,2.1-1.2c0.5-0.7,0.7-1.5,0.6-2.4C15,10.1,13.9,9,12.5,8.8z"
      />
      <path
        fill="currentColor"
        d="M17,2H7C4.2,2,2,4.2,2,7v10c0,2.8,2.2,5,5,5h10c2.8,0,5-2.2,5-5V7C22,4.2,19.8,2,17,2z M15.9,14.8
        c-0.8,1-1.9,1.7-3.2,1.9c-0.2,0-0.5,0.1-0.7,0.1c-2.4,0-4.4-1.7-4.8-4.1C6.9,10,8.7,7.6,11.3,7.2c0.5-0.1,0.9-0.1,1.4,0
        c2.1,0.3,3.8,2,4.1,4.1C17,12.5,16.7,13.8,15.9,14.8z M17.5,7.3c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h0c0.5,0,0.8,0.4,0.8,0.8
        S18,7.3,17.5,7.3z"
      />
    </svg>
  );
}
